import { render, staticRenderFns } from "./ArticleBox.vue?vue&type=template&id=59cfa9e8&scoped=true"
import script from "./ArticleBox.vue?vue&type=script&lang=js"
export * from "./ArticleBox.vue?vue&type=script&lang=js"
import style0 from "./ArticleBox.vue?vue&type=style&index=0&id=59cfa9e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cfa9e8",
  null
  
)

export default component.exports